import React from "react";

import "./styles.css";

const PlaceholderOption = ({ value }) => {
  return <span className="invitation-dropdown-placeholder">{value}</span>;
};

export default PlaceholderOption;
